window.global ||= window

import React from 'react'
import { createRoot } from 'react-dom/client'
import structuredClone from '@ungap/structured-clone'
import App from './App'
import * as Sentry from '@sentry/react'
import BuildInfo from './build-info'
import './i18n'
import './index.css'

if (!('structuredClone' in window)) {
    /* @ts-ignore */
    window.structuredClone = structuredClone
}

console.log(`index.js: loaded BuildInfo=` + JSON.stringify(BuildInfo))

if (window.origin && window.origin.indexOf('localhost') >= 0) {
    console.log(`index.js: detected dev environment.`)
    // Do not set up Sentry in dev environment as we don't want to pollute
    // Sentry with errors generated during development.
} else {
    console.log(`index.js: detected prod environment.`)
    console.log(`index.js: Setting up Sentry for the React renderer thread.`)
    Sentry.init({
        dsn: 'https://45374a5b50b9402aaa34ac8544ddbd30@o1296731.ingest.us.sentry.io/6524018',
        release: BuildInfo.app_version_full,
    })
}

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
